import { immer } from 'zustand/middleware/immer';
import { create } from 'zustand/react';

interface AdsStore {
  showAds: {
    bannerBoottom: boolean;
  };
  closeAds: (key: string, value: boolean) => void;
}

export const useAdsStore = create<AdsStore>()(
  immer((set) => ({
    showAds: {
      bannerBoottom: true,
    },

    closeAds: (key, value) => {
      set((state) => {
        if (key === 'bannerBoottom') {
          state.showAds.bannerBoottom = value;
        }
      });
    },
  })),
);
